import { Box, Paper, Typography } from "@mui/material";
import React from "react";

export default function Error404() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        top: "50%",
        bottom: "50%",
      }}
    >
      <Paper
        variant="outlined"
        sx={{
          p: 5,
          width: { xs: "100%", sm: "50%" },
          borderRadius: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" component="div">
            ERROR 404
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
}
